// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import type {
  GenerateAccessTokenUsingPostData,
  GenerateAccessTokenUsingPostErrors,
  GenerateAccessTokenUsingPostResponses,
  ProcessSoftwareStatementUsingPostData,
  ProcessSoftwareStatementUsingPostErrors,
  ProcessSoftwareStatementUsingPostResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export class DynamicClientRegistrationApi {
  /**
   * Register client application
   * Get client credentials for a software statement and get scopes information
   */
  public static processSoftwareStatementUsingPost<
    ThrowOnError extends boolean = false,
  >(options: Options<ProcessSoftwareStatementUsingPostData, ThrowOnError>) {
    return (options.client ?? client).post<
      ProcessSoftwareStatementUsingPostResponses,
      ProcessSoftwareStatementUsingPostErrors,
      ThrowOnError
    >({
      url: '/client/register',
      ...options,
    })
  }

  /**
   * Retrieve client token
   * Get access token for a pair of client credentials
   */
  public static generateAccessTokenUsingPost<
    ThrowOnError extends boolean = false,
  >(options: Options<GenerateAccessTokenUsingPostData, ThrowOnError>) {
    return (options.client ?? client).post<
      GenerateAccessTokenUsingPostResponses,
      GenerateAccessTokenUsingPostErrors,
      ThrowOnError
    >({
      url: '/client/token',
      ...options,
    })
  }
}
